import axios from "axios";

const instance = axios.create({
  baseURL: "",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

instance.interceptors.request.use((request) => {
  const token = localStorage.getItem("token");
  if (token) {
    request.headers = request.headers || {};
    request.headers.Authorization = `Bearer ${token}`;
  }
  if (typeof window === "undefined" || typeof request.url !== "string") {
    return request;
  }
  const origin = window.location.origin;
  let url = request.url;
  if (/^http:\/\//i.test(url)) {
    url = url.replace(/^http:\/\//i, "https://");
  }
  if (
    /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i.test(url) ||
    /^https?:\/\/[^/]*invest\.myvexx\.com:3001/i.test(url)
  ) {
    url = url.replace(/^https?:\/\/[^/]+/i, "");
  }
  if (url.startsWith("/")) {
    request.baseURL = origin;
    request.url = url;
  } else {
    request.url = url;
  }
  return request;
});

instance.interceptors.response.use(
  (r) => r,
  (e) => Promise.reject(e)
);

export default instance;
